import Products from 'pages/Settings/Products/shared/components/Products'
import { wheatProductsAdapter } from 'pages/Settings/Products/shared/adapters/wheat'

export const WheatProductsPage = () => {
  return <Products adapter={wheatProductsAdapter} />
}
